import styled from 'styled-components';

const Topo = styled.div`
  display: grid;
  justify-content: center;
  align-content: center;
  text-align: center;

  h1 {
    font-family: 'Bebas Neue', cursive;
  }
`;

export default Topo;
